module.exports = __webpack_public_path__ + "0fd65ed9c5b8dcbb3dd0862e46cd8445.svg";